import * as React from 'react';

import {
	Alert,
	Box,
	Button,
	CircularProgress,
	Paper,
	Stack,
	TextField,
	Typography,
} from '@mui/material';

import { useLogin } from './hooks';

import s from './Login.scss';

export const Login = () => {
	const {
		login,
		password,
		networkStatus,
		onLoginChange,
		onPasswordChange,
		onSubmit,
	} = useLogin();

	const handleLoginChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		onLoginChange(event.target.value);
	};

	const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		onPasswordChange(event.target.value);
	};

	const handleSubmit = (event: React.FormEvent) => {
		event.preventDefault();
		void onSubmit();
	};

	return (
		<div className={s.root}>
			<Paper className={s.paper}>
				<Box component="form" onSubmit={handleSubmit}>
					<Stack spacing={2}>
						<Typography variant="h5" sx={{ textAlign: 'center' }}>
							Вход
						</Typography>

						{networkStatus.error && (
							<Alert severity="error">
								Неверный логин или пароль
							</Alert>
						)}

						<TextField
							label="Логин"
							value={login}
							onChange={handleLoginChange}
							autoFocus
						/>

						<TextField
							label="Пароль"
							type="password"
							value={password}
							onChange={handlePasswordChange}
						/>

						<Button
							type="submit"
							variant="contained"
							disabled={networkStatus.isFetching || !login || !password}
						>
							{networkStatus.isFetching ? <CircularProgress size={24} /> : 'Войти'}
						</Button>
					</Stack>
				</Box>
			</Paper>
		</div>
	);
};
